/* SoundKey — scripts du thème (sans dépendance) */
(function () {
  'use strict';
  var S = window.skStrings || {};

  /* ---------- Menu mobile ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sk-menu-toggle]');
    if (!toggle) return;
    var menu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!menu) return;
    var open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? (S.menuClose || '') : (S.menuOpen || ''));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-sk-menu].is-open').forEach(function (m) {
      m.classList.remove('is-open');
      var t = document.querySelector('[aria-controls="' + m.id + '"]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    });
  });

  /* ---------- Bouton partager ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sk-share]');
    if (!btn) return;
    var data = { title: btn.dataset.title || document.title, url: btn.dataset.url || location.href };
    if (navigator.share) {
      navigator.share(data).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(data.url).then(function () {
        var old = btn.getAttribute('aria-label');
        btn.setAttribute('aria-label', S.linkCopied);
        btn.title = S.linkCopied;
        setTimeout(function () { btn.setAttribute('aria-label', old); btn.title = ''; }, 2000);
      });
    }
  });

  /* ---------- Sélecteurs de quantité ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-sk-qty-minus]');
    var plus = e.target.closest('[data-sk-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-sk-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var val = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Panier : envoi automatique quand la quantité change ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-sk-cart-qty]');
    if (!input) return;
    var form = input.form;
    clearTimeout(form._skTimer);
    form._skTimer = setTimeout(function () { form.submit(); }, 500);
  });

  /* ---------- Page de personnalisation ---------- */
  function initProduct(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('[data-sk-variant-id]');
    var priceEl = root.querySelector('[data-sk-price]');
    var addBtn = form.querySelector('[data-sk-add]');

    function showMedia(id) {
      if (!id) return;
      var slides = root.querySelectorAll('.sk-product__slide');
      var target = root.querySelector('.sk-product__slide[data-media-id="' + id + '"]');
      if (!target) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', s === target); });
      root.querySelectorAll('[data-sk-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t.dataset.skThumb === String(id) ? 'true' : 'false');
      });
    }

    function setMode(mode) {
      root.querySelectorAll('[data-sk-mode]').forEach(function (box) {
        var active = box.dataset.skMode === mode;
        box.hidden = !active;
        box.querySelectorAll('input, textarea, select').forEach(function (f) { f.disabled = !active; });
      });
      root.querySelectorAll('[data-sk-mode-title]').forEach(function (t) {
        t.hidden = t.dataset.skModeTitle !== mode;
      });
    }

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-sk-thumb]');
      if (thumb) showMedia(thumb.dataset.skThumb);
    });

    root.querySelectorAll('[data-sk-variant]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        idInput.value = radio.value;
        setMode(radio.dataset.mode);
        if (priceEl) {
          priceEl.innerHTML = radio.dataset.price + (radio.dataset.compare ? '<s>' + radio.dataset.compare + '</s>' : '');
        }
        if (addBtn) {
          var ok = radio.dataset.available === 'true';
          addBtn.disabled = !ok;
          addBtn.textContent = ok ? addBtn.dataset.label : addBtn.dataset.soldout;
        }
        showMedia(radio.dataset.mediaId);
        var url = new URL(location.href);
        url.searchParams.set('variant', radio.value);
        history.replaceState({}, '', url.toString());
      });
    });

    /* Lien : ajoute https:// si le client l'a oublié */
    root.querySelectorAll('[data-sk-url]').forEach(function (input) {
      input.addEventListener('blur', function () {
        var v = input.value.trim();
        if (v && !/^https?:\/\//i.test(v)) input.value = 'https://' + v;
      });
    });

    /* Aperçu de l'image envoyée */
    root.querySelectorAll('[data-sk-upload]').forEach(function (input) {
      input.addEventListener('change', function () {
        var box = input.closest('.sk-upload');
        var preview = box.querySelector('[data-sk-upload-preview]');
        var icon = box.querySelector('[data-sk-upload-icon]');
        var name = box.querySelector('[data-sk-upload-name]');
        var file = input.files && input.files[0];
        if (!file) return;
        if (file.size > 20 * 1024 * 1024) {
          alert(S.imageTooBig);
          input.value = '';
          return;
        }
        name.textContent = file.name;
        if (preview && file.type.indexOf('image/') === 0) {
          preview.src = URL.createObjectURL(file);
          preview.hidden = false;
          if (icon) icon.hidden = true;
        }
      });
    });

    /* Validation avant ajout au panier */
    form.addEventListener('submit', function (e) {
      if (!form.checkValidity()) {
        e.preventDefault();
        var firstInvalid = form.querySelector(':invalid:not(fieldset)');
        if (firstInvalid) { firstInvalid.focus(); form.reportValidity(); }
        return;
      }
      if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = S.adding; }
    });
  }

  /* ---------- Page de personnalisation CD / vinyle ---------- */
  var PLATFORMS = [
    [/spotify\.com|spotify\.link/i, 'Spotify'],
    [/music\.youtube\.com/i, 'YouTube Music'],
    [/youtube\.com|youtu\.be/i, 'YouTube'],
    [/music\.apple\.com|itunes\.apple\.com/i, 'Apple Music'],
    [/deezer\.com|deezer\.page\.link/i, 'Deezer'],
    [/soundcloud\.com/i, 'SoundCloud'],
    [/tidal\.com/i, 'Tidal'],
    [/amazon\.[a-z.]+\/music|music\.amazon/i, 'Amazon Music']
  ];
  function platformOf(url) {
    for (var i = 0; i < PLATFORMS.length; i++) if (PLATFORMS[i][0].test(url)) return PLATFORMS[i][1];
    return '';
  }
  function fetchCover(url) {
    var endpoint = null;
    if (/spotify\.com/i.test(url)) endpoint = 'https://open.spotify.com/oembed?url=' + encodeURIComponent(url);
    else if (/youtube\.com|youtu\.be/i.test(url)) endpoint = 'https://noembed.com/embed?url=' + encodeURIComponent(url.replace('music.youtube.com', 'www.youtube.com'));
    if (!endpoint) return Promise.resolve('');
    return fetch(endpoint).then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) { return (d && d.thumbnail_url) || ''; })
      .catch(function () { return ''; });
  }

  function initConfigurator(root) {
    var form = root.querySelector('[data-sk-config-form]');
    if (!form || root._skReady) return;
    root._skReady = true;
    var preview = root.querySelector('[data-sk-preview]');
    var img = root.querySelector('[data-sk-preview-img]');
    var idInput = form.querySelector('[data-sk-variant-id]');
    var addBtn = form.querySelector('[data-sk-add]');
    var totalEl = root.querySelector('[data-sk-total]');
    var qtyInput = form.querySelector('[data-sk-quantity]');
    var nameEl = root.querySelector('[data-sk-summary-name]');
    var optEl = root.querySelector('[data-sk-summary-option]');
    var platformEl = root.querySelector('[data-sk-platform]');
    var isDemo = root.hasAttribute('data-demo');
    var state = { mode: preview.dataset.mode, uploadUrl: '', coverUrl: '', price: '' };

    function currentFormat() {
      var f = root.querySelector('[data-sk-format]:checked');
      return f ? f.value : 'cd';
    }
    function currentVariant() {
      var group = root.querySelector('[data-sk-options="' + currentFormat() + '"]');
      return group ? group.querySelector('[data-sk-variant]:checked') : null;
    }
    function refreshImage() {
      var src = state.mode === 'ai' ? state.uploadUrl : state.coverUrl;
      if (src) { img.src = src; img.hidden = false; }
      else { img.hidden = true; img.removeAttribute('src'); }
      root.querySelectorAll('[data-sk-cover]').forEach(function (el) {
        var key = state.mode === 'ai' ? (state.uploadUrl ? 'ai-image' : 'ai') : 'link';
        el.hidden = el.dataset.skCover !== key;
      });
    }
    function refreshTotal() {
      if (!totalEl || !state.price) return;
      var q = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10));
      if (q === 1) { totalEl.textContent = state.price; return; }
      var num = parseFloat(state.price.replace(/[^0-9.,]/g, '').replace(/[.,](?=\d{3}(\D|$))/g, '').replace(',', '.'));
      if (isNaN(num)) { totalEl.textContent = state.price; return; }
      var total = (num * q).toFixed(2);
      totalEl.textContent = state.price.replace(/[0-9][0-9.,'’ ]*[0-9]/, total);
    }
    function setMode(mode) {
      state.mode = mode;
      preview.dataset.mode = mode;
      root.querySelectorAll('[data-sk-mode]').forEach(function (box) {
        var active = box.dataset.skMode === mode;
        box.hidden = !active;
        box.querySelectorAll('input, textarea, select').forEach(function (f) { f.disabled = !active; });
      });
      root.querySelectorAll('[data-sk-mode-title]').forEach(function (t) { t.hidden = t.dataset.skModeTitle !== mode; });
      if (platformEl) platformEl.hidden = mode !== 'link' || !platformEl.textContent;
      refreshImage();
    }
    function applyVariant(radio) {
      if (!radio) return;
      idInput.value = radio.value;
      state.price = radio.dataset.price;
      if (optEl) optEl.textContent = radio.dataset.title;
      setMode(radio.dataset.mode);
      refreshTotal();
      if (addBtn) {
        var ok = radio.dataset.available === 'true' && !isDemo;
        addBtn.disabled = !ok;
        addBtn.textContent = (ok || isDemo) ? addBtn.dataset.label : addBtn.dataset.soldout;
      }
    }
    function applyFormat(fmt, preferredMode) {
      preview.dataset.format = fmt;
      var radio = root.querySelector('[data-sk-format][value="' + fmt + '"]');
      if (radio && nameEl) nameEl.textContent = radio.dataset.title;
      root.querySelectorAll('[data-sk-options]').forEach(function (group) {
        var active = group.dataset.skOptions === fmt;
        group.hidden = !active;
        group.querySelectorAll('[data-sk-variant]').forEach(function (r) { r.tabIndex = active ? 0 : -1; });
      });
      var group = root.querySelector('[data-sk-options="' + fmt + '"]');
      if (!group) return;
      var pick = null;
      var wanted = preferredMode || state.mode;
      group.querySelectorAll('[data-sk-variant]:not(:disabled)').forEach(function (r) {
        if (!pick && r.dataset.mode === wanted) pick = r;
      });
      pick = pick || group.querySelector('[data-sk-variant]:checked') || group.querySelector('[data-sk-variant]:not(:disabled)');
      if (pick) { pick.checked = true; applyVariant(pick); }
    }

    root.querySelectorAll('[data-sk-format]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        applyFormat(r.value);
        var url = new URL(location.href);
        url.searchParams.set('format', r.value);
        history.replaceState({}, '', url.toString());
      });
    });
    root.querySelectorAll('[data-sk-variant]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        applyVariant(r);
        var url = new URL(location.href);
        if (r.dataset.mode === 'ai') url.searchParams.set('option', 'ia'); else url.searchParams.delete('option');
        history.replaceState({}, '', url.toString());
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', refreshTotal);

    /* Lien : plateforme + pochette */
    var linkInput = form.querySelector('[data-sk-url]');
    var coverTimer;
    function onLink() {
      var v = linkInput.value.trim();
      var name = v ? platformOf(v) : '';
      if (platformEl) {
        platformEl.hidden = !name || state.mode !== 'link';
        platformEl.textContent = name ? (S.opensOn || '%s').replace('%s', name) : '';
      }
      clearTimeout(coverTimer);
      if (!root.hasAttribute('data-fetch-cover')) return;
      coverTimer = setTimeout(function () {
        if (!/^https?:\/\//i.test(v)) { state.coverUrl = ''; refreshImage(); return; }
        fetchCover(v).then(function (src) {
          if (linkInput.value.trim() !== v) return;
          state.coverUrl = src; refreshImage();
        });
      }, 500);
    }
    if (linkInput) {
      linkInput.addEventListener('input', onLink);
      linkInput.addEventListener('blur', function () {
        var v = linkInput.value.trim();
        if (v && !/^https?:\/\//i.test(v)) { linkInput.value = 'https://' + v; onLink(); }
      });
    }

    /* Image envoyée pour l'IA */
    var upload = form.querySelector('[data-sk-upload]');
    if (upload) {
      upload.addEventListener('change', function () {
        var box = upload.closest('.sk-upload');
        var file = upload.files && upload.files[0];
        if (!file) return;
        if (file.size > 20 * 1024 * 1024) { alert(S.imageTooBig); upload.value = ''; return; }
        box.querySelector('[data-sk-upload-name]').textContent = file.name;
        if (file.type.indexOf('image/') === 0) {
          state.uploadUrl = URL.createObjectURL(file);
          var thumb = box.querySelector('[data-sk-upload-preview]');
          thumb.src = state.uploadUrl; thumb.hidden = false;
          var icon = box.querySelector('[data-sk-upload-icon]');
          if (icon) icon.hidden = true;
          refreshImage();
        }
      });
    }

    form.addEventListener('submit', function (e) {
      if (isDemo || !idInput.value) { e.preventDefault(); return; }
      if (!form.checkValidity()) {
        e.preventDefault();
        var bad = form.querySelector(':invalid:not(fieldset)');
        if (bad) { bad.focus(); form.reportValidity(); }
        return;
      }
      if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = S.adding; }
    });

    /* Présélection depuis l'URL : ?format=vinyle&option=ia */
    var params = new URLSearchParams(location.search);
    var fmt = params.get('format');
    var wantAi = params.get('option') === 'ia';
    var fmtRadio = fmt && root.querySelector('[data-sk-format][value="' + fmt + '"]');
    if (fmtRadio) fmtRadio.checked = true;
    applyFormat(currentFormat(), wantAi ? 'ai' : (currentVariant() ? currentVariant().dataset.mode : 'link'));
  }

  function initAll() {
    document.querySelectorAll('[data-sk-config]').forEach(initConfigurator);
    document.querySelectorAll('[data-sk-product]').forEach(initProduct);
    /* Formulaires d'adresse : présélectionne le pays enregistré */
    document.querySelectorAll('select[data-sk-default]').forEach(function (sel) {
      if (sel.dataset.skDefault) sel.value = sel.dataset.skDefault;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Retour arrière (cache du navigateur) : réactive le bouton */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-sk-add][aria-disabled="true"]').forEach(function (b) {
      b.removeAttribute('aria-disabled');
      b.textContent = b.disabled ? b.dataset.soldout : b.dataset.label;
    });
  });

  /* Rechargement des sections dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sk-product]');
    if (root) initProduct(root);
    var cfg = e.target.querySelector('[data-sk-config]');
    if (cfg) initConfigurator(cfg);
  });
})();
